import { AppPath } from "../common/AppPath";

export default function LoginButton() {
    return (
        <a className="navbar-item link" href={AppPath.LOGIN}>
            Logg inn
        </a>
    );
}
